import React, { useState } from "react";
import "../../style.css";
import BootstrapTable from "react-bootstrap-table-next";
import {
  commonHeaderStyle,
  commonStyle,
  displayNullFormatter,
  rowStyle2,
} from "containers/gstr2a2bNewEnhancement/Utility/utility";
import download from "images/download.svg";
import EmailOutlinedIcon from "@material-ui/icons/EmailOutlined";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import CloseIcon from "@material-ui/icons/Close";
import { Typography } from "@material-ui/core";
import ComposeMailFunctional from "./ComposeMailFunctional";
import { useDispatch, useSelector } from "react-redux";
import { downloadRecoHistoryIndividualExcel } from "../action";
import NoData from "containers/gstr2a2bNewEnhancement/Utility/NoData";
import moment from "moment";
import ReactPaginate from "react-paginate";
import MultiplePopup from "containers/gstr2a2bNewEnhancement/Utility/MultiplePopup";
import { extractMonthsInRange } from "utils/extractMonths";

// Formatter for Generation Timestamp
const generationTimestampFormatter = (cell, row) => {
  if (!row.CREATED_DATE) return "-";
  return moment(row.CREATED_DATE, "YYYY-MM-DD HH:mm:ss.SSS Z").format(
    "DD-MM-YYYY HH:mm:ss"
  );
};

// Formatter for STATUS column
const statusFormatter = (cell, row) => {
  const status = row?.PIPELINE_STATUS?.toUpperCase();
  
  // Helper function to convert status to proper case
  const getDisplayStatus = (originalStatus) => {
    if (!originalStatus) return "In-progress";
    return originalStatus.charAt(0).toUpperCase() + originalStatus.slice(1).toLowerCase();
  };
  
  return (
    <div
      style={{
        cursor: status === "FAILED" ? "pointer" : "auto",
        width: "100%",
        textAlign: "center",
        color:
          status === "FAILED"
            ? "red"
            : status === "COMPLETED"
            ? "green"
            : "#000",
      }}
    >
      {status === "COMPLETED" || status === "FAILED"
        ? getDisplayStatus(row.PIPELINE_STATUS)
        : "In-progress"}
    </div>
  );
};

// Action column formatter
const actionFormatter = (cell, row, rowIndex, formatExtraData) => {
  const { handleDownload, handleMailOpen } = formatExtraData || {};
  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        justifyContent: "center",
      }}
    >
      <div>
        <img
          src={download}
          alt="download"
          style={{
            width: "20px",
            height: "14px",
            cursor:
              row?.PIPELINE_STATUS?.toUpperCase() === "COMPLETED"
                ? "pointer"
                : "not-allowed",
          }}
          onClick={
            row?.PIPELINE_STATUS?.toUpperCase() === "COMPLETED"
              ? () => handleDownload && handleDownload(row)
              : null
          }
        />
      </div>
      <div
        style={{
          marginLeft: "15px",
          cursor:
            row?.PIPELINE_STATUS?.toUpperCase() === "COMPLETED"
              ? "pointer"
              : "not-allowed",
        }}
        onClick={
          row?.PIPELINE_STATUS?.toUpperCase() === "COMPLETED"
            ? () => handleMailOpen && handleMailOpen(row)
            : null
        }
      >
        <EmailOutlinedIcon style={{ color: "#4F2D7F", fontSize: "16px" }} />
      </div>
    </div>
  );
};

const Table = (props) => {
  const { recoHistoryTableData, totalPagesRecoHistory, selection, dateRange } = useSelector(
    (state) => state.gstr2a2bNewRecoReducer
  );

  const dispatch = useDispatch();
  const [mailOpen, setMailOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState({});
  const handleMailClose = () => setMailOpen(false);

  const getSelectedRetPeriod = () => {
    if (selection === "Document Date") return "";

    const startDate = dateRange?.[0]?.startDate ? new Date(dateRange[0].startDate) : null;
    const endDate = dateRange?.[0]?.endDate ? new Date(dateRange[0].endDate) : startDate;

    if (!startDate || !endDate || Number.isNaN(startDate.getTime()) || Number.isNaN(endDate.getTime())) {
      return "";
    }

    const monthRange = extractMonthsInRange(startDate, endDate);
    return Array.isArray(monthRange) && monthRange.length > 0
      ? monthRange.join(",")
      : "";
  };

  const handleMailOpen = (row) => {
    const selectedRetPeriod = getSelectedRetPeriod();
    setMailOpen(true);
    setSelectedRow(
      selectedRetPeriod
        ? { ...row, SELECTED_RET_PERIOD: selectedRetPeriod }
        : row
    );
  };

  const [open, setOpen] = useState(false);
  const [dialogName, setDialogName] = useState("");
  const [selectedRecord, setSelectedRecord] = useState([]);

  const handleMultiple = async (row, type) => {
    try {
      if (type === "Multiple Gstins") {
        setSelectedRecord(Array.isArray(row.GSTIN) ? row.GSTIN : [row.GSTIN]);
      } else {
        setSelectedRecord(
          Array.isArray(row.RET_PERIOD) ? row.RET_PERIOD : [row.RET_PERIOD]
        );
      }
      setDialogName(type);
      setOpen(true);
    } catch (error) {
      console.error("Error in handleMultiple:", error);
    }
  };
  const gstinColumnFormatter = (cell, row) => {
    // Split GSTIN string by comma and filter out empty values
    const gstins =
      typeof row.GSTIN === "string"
        ? row.GSTIN.split(",")
            .map((g) => g.trim())
            .filter(Boolean)
        : [row.GSTIN];

    const isMultiple = gstins.length > 1;
    const displayText = isMultiple ? "Multiple" : gstins[0] || "";

    return (
      <div
        style={{
          width: "100%",
          cursor: isMultiple ? "pointer" : "default",
          textDecoration: isMultiple ? "underline" : null,
          fontWeight: isMultiple ? "bold" : "normal",
          fontSize: "11px",
        }}
        onClick={
          isMultiple ? () => handleMultiple(row, "Multiple Gstins") : null
        }
      >
        {displayText}
      </div>
    );
  };
  const handleDownload = (row) => {
    if (row?.PIPELINE_STATUS?.toUpperCase() !== "COMPLETED") {
      return;
    }
    dispatch(downloadRecoHistoryIndividualExcel(row));
  };

  const columns = [
    {
      dataField: "UUID",
      text: "Reco ID",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "20%",
      },
      formatter: (cell, row) => displayNullFormatter(row, "UUID"),
    },
    {
      dataField: "GSTIN",
      text: "GSTIN",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "20%",
      },
      formatter: gstinColumnFormatter,
    },
    {
      dataField: "PR_FISCAL_YEAR",
      text: "Financial Year",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "20%",
      },
      formatter: (cell, row) => displayNullFormatter(row, "PR_FISCAL_YEAR"),
    },
    {
      dataField: "PIPELINE_STATUS",
      text: "Status",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "20%",
      },
      formatter: statusFormatter,
    },
    {
      dataField: "CREATED_DATETIME",
      text: "Generation Timestamp",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "20%",
      },
      // formatter: generationTimestampFormatter,
      formatter: (col, row) => {
        return (
          <>{moment(row.CREATED_DATETIME).format("DD/MM/YYYY HH:mm:ss")}</>
        );
      },
    },
    {
      dataField: "",
      text: "Action",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "20%",
      },
      formatter: actionFormatter,
      formatExtraData: {
        handleDownload,
        handleMailOpen,
      },
    },
  ];

  return (
    <>
      {recoHistoryTableData?.length > 0 ? (
        <>
          <div
            className="light-border-gstr2a2bnew-table"
            style={{
              marginTop: "0.6em",
              // height: "25em",
            }}
          >
            <BootstrapTable
              keyField="ID"
              data={recoHistoryTableData}
              columns={columns}
              rowStyle={rowStyle2}
            />

            <Dialog
              aria-labelledby="customized-dialog-title"
              fullWidth={true}
              maxWidth="md"
              open={mailOpen}
            >
              <MuiDialogTitle
                disableTypography
                style={{ backgroundColor: "#4f2d7f", color: "white" }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <Typography variant="h6">{"Compose Mail"}</Typography>
                  <CloseIcon
                    onClick={handleMailClose}
                    color="white"
                    style={{ cursor: "pointer" }}
                  />
                </div>
              </MuiDialogTitle>
              <MuiDialogContent dividers>
                <div style={{ marginBottom: "4%" }}>
                  <ComposeMailFunctional
                    selectedRow={selectedRow}
                    profileData={props.profileData}
                    closeMailModal={handleMailClose}
                  />
                </div>
              </MuiDialogContent>
            </Dialog>

            <MultiplePopup
              open={open}
              onClose={() => setOpen(false)}
              dialogName={dialogName}
              selectedRecord={selectedRecord}
            />
          </div>
          <br />
          <ReactPaginate
            previousLabel={"previous"}
            nextLabel={"next"}
            breakLabel={"..."}
            breakClassName={"break-me"}
            pageCount={totalPagesRecoHistory}
            marginPagesDisplayed={2}
            pageRangeDisplayed={3}
            onPageChange={props.handlePageClick}
            containerClassName={"pagination"}
            subContainerClassName={"pages pagination"}
            activeClassName={"active"}
          />
        </>
      ) : (
        <NoData />
      )}
    </>
  );
};

export default Table;
